<template>
    <v-container>
        <v-subheader inset>Wish Lists Data Table</v-subheader>
        <v-data-table :headers="headers" :items="items">
            <template v-slot:[`item.media`]="{
                        item,
                    }">
                <v-container v-if="item" class="d-flex justify-self-center pa-0 feathered">
                    <v-img v-if="!$mobile && item.media" width="150" height="200" lazy-src="https://picsum.photos/id/497/1080/1080" @click="item.media.length ?
                                imageOverlays[item.id] = !imageOverlays[item.id] : ''
                            " :src="$near.ipfsAdapter(item.media)"></v-img>
                    <v-overlay v-if="item.media" z-index="10" :value="isOverlayOn(item.id)" @click="
                                imageOverlays[item.id] = !imageOverlays[item.id]
                            ">
                        <v-img class="rounded-xl" :src="$near.ipfsAdapter(item.media)"></v-img>
                    </v-overlay>
                </v-container>
            </template>
            <template v-slot:[`item.id`]="{
                        item,
                    }">
                <router-link :to="{ path: `/wishlist/${item.id}` }" class="no-decoration ml-2" style="text-decoration: none">{{ item.id }}</router-link>
            </template>
            <template v-slot:[`item.items`]="{
                        item,
                    }">
                <v-container class="d-flex justify-self-center pa-0 feathered" v-if="item">
                    <v-img v-for="wishlistItem of withMediaFilter(item)" v-bind:key="`img-${overlayId(item, wishlistItem)}`" :width="withMediaFilter(item).length ? 150 / withMediaFilter(item).length : 150" height="200" lazy-src="https://picsum.photos/id/497/1080/1080" @click="
                                imageOverlays[overlayId(item, wishlistItem)] = !imageOverlays[overlayId(item, wishlistItem)]
                            " :src="$near.ipfsAdapter(wishlistItem.media)"></v-img>
                    <v-overlay v-for="wishlistItem of withMediaFilter(item)" v-bind:key="overlayId(item, wishlistItem)" z-index="10" :value="isOverlayOn(overlayId(item, wishlistItem))" @click="
                                imageOverlays[overlayId(item, wishlistItem)] = !imageOverlays[overlayId(item, wishlistItem)]
                            ">
                        <v-img class="rounded-xl" :src="$near.ipfsAdapter(wishlistItem.media)"></v-img>
                    </v-overlay>
                </v-container>
            </template>
        </v-data-table>
    </v-container>
</template>
<script>
export default {
    name: 'BnftWishlistsAdmin_WishlistTable',
    props: {
        items: Array,
    },
    watch: {
        wishlists(value) {
            const self = this;
            value.map(wishlist => wishlist.items.map(item => self.$set(self.imageOverlays, self.overlayId(wishlist, item), false)));
        }
    },
    methods: {
        isOverlayOn(overlayId) {
            if (this.imageOverlays[overlayId] === undefined)
                this.$set(this.imageOverlays, overlayId, false);
            return (
                this.imageOverlays[overlayId] && this.flickerTimeout
            );
        },
        withMediaFilter(wishlist) {
            return wishlist && wishlist.items ? wishlist.items.filter(item => item.media && item.media.length) : [];
        },
        overlayId(wishlist, item) {
            return wishlist?.id && item?.id?.gtin ? `${wishlist.id}:${item.id.gtin}` : undefined;
        }
    },
    data: function () {
        return {
            ipfsCompatible: undefined,
            wishlists: undefined,
            giverIds: undefined,
            imageOverlays: {},
            headers: [
                { text: `db`, value: 'db' },
                { text: `media`, value: 'media' },
                { text: `owner`, value: 'owner' },
                { text: `id`, value: 'id' },
                { text: `items`, value: 'items' },
            ],
            flickerTimeout: false,
        };
    },
}
</script>
